import React, { useState, useEffect } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaToggleOn, FaToggleOff } from "react-icons/fa";
import { isAutheticated } from "../../auth/authhelper"; // Ensure correct path
import { API } from "../../../API"; // Ensure correct path
import { Spinner } from "react-bootstrap"; // Bootstrap spinner for loading state

const SubscriptionTypes = () => {
    const { token } = isAutheticated();

    const [loginRequired, setLoginRequired] = useState(false);
    const [payRequired, setPayRequired] = useState(false);
    const [subscriptionRequired, setSubscriptionRequired] = useState(false);
    const [plans, setPlans] = useState({
        monthly: { enabled: false, value: "" },
        quarterly: { enabled: false, value: "" },
        halfYearly: { enabled: false, value: "" },
        yearly: { enabled: false, value: "" },
    });

    const [loading, setLoading] = useState(false); // Loading state for fetching data
    const [submitting, setSubmitting] = useState(false); // Submitting state for form submission

    // Fetch existing settings when component mounts
    useEffect(() => {
        setLoading(true); // Set loading state to true while data is being fetched
        axios.get(`${API}/api/subscription/setting`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => {
                const { data } = response?.data;
                console.log('data', data);

                // Ensure the data contains the expected properties before setting state
                if (data) {
                    setLoginRequired(data.loginRequired || false);
                    setPayRequired(data.payRequired || false);
                    setSubscriptionRequired(data.subscriptionRequired || false);
                    setPlans({
                        monthly: data?.plans?.monthly || { enabled: false, value: "" },
                        quarterly: data?.plans?.quarterly || { enabled: false, value: "" },
                        halfYearly: data?.plans.halfYearly || { enabled: false, value: "" },
                        yearly: data?.plans.yearly || { enabled: false, value: "" },
                    });
                }
            })
            .catch(err => {
                const errorMessage = err.response?.data?.error || err.message || 'An error occurred while fetching the subscription settings';
                alert(`Error fetching subscription settings: ${errorMessage}`);
                console.error("Error fetching subscription settings:", err);
            })
            .finally(() => setLoading(false)); // Set loading state to false once data is fetched
    }, [token]);

    const handlePlanChange = (plan, field, value) => {
        setPlans(prevPlans => ({
            ...prevPlans,
            [plan]: {
                ...prevPlans[plan],
                [field]: value,
            },
        }));
    };

    const handleSubmit = () => {
        setSubmitting(true); // Set submitting state to true while data is being submitted
        axios.post(`${API}/api/subscription/setting`, {
            loginRequired,
            payRequired,
            subscriptionRequired,
            plans
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(response => {
                alert("Subscription settings updated successfully");
            })
            .catch(err => {
                alert(`Failed to update subscription settings: ${err.response?.data?.error || err.message}`);
                console.error(err);
            })
            .finally(() => setSubmitting(false)); // Set submitting state to false once submission is complete
    };

    return (
        <div className="main-content bg-light py-4">
            <div className="container mt-5">
                <div className="card shadow p-4">
                    <h2 className="text-center text-primary mb-4">Subscription Settings</h2>

                    {/* Loading Indicator */}
                    {loading ? (
                        <div className="d-flex justify-content-center">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            {/* Login Required Toggle */}
                            {/* <div className="d-flex align-items-center justify-content-between p-3 bg-white shadow-sm rounded mb-3">
                                <div className="d-flex align-items-center">
                                    <span className="me-3 fw-bold">Login Required:</span>
                                    {loginRequired ? <FaToggleOn size={20} color="green" /> : <FaToggleOff size={20} color="red" />}
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={loginRequired}
                                        onChange={() => setLoginRequired(!loginRequired)}
                                    />
                                    <label className="form-check-label">Enabled</label>
                                </div>
                            </div> */}

                            {/* Pay Required Toggle */}
                            {/* <div className="d-flex align-items-center justify-content-between p-3 bg-white shadow-sm rounded mb-3">
                                <div className="d-flex align-items-center">
                                    <span className="me-3 fw-bold">Pay Required:</span>
                                    {payRequired ? <FaToggleOn size={20} color="green" /> : <FaToggleOff size={20} color="red" />}
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={payRequired}
                                        onChange={() => setPayRequired(!payRequired)}
                                    />
                                    <label className="form-check-label">Enabled</label>
                                </div>
                            </div> */}

                            {/* Subscription Required Toggle */}
                            <div className="d-flex align-items-center justify-content-between p-3 bg-white shadow-sm rounded mb-3">
                                <div className="d-flex align-items-center">
                                    <span className="me-3 fw-bold">Subscription Required:</span>
                                    {subscriptionRequired ? <FaToggleOn size={20} color="green" /> : <FaToggleOff size={20} color="red" />}
                                </div>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={subscriptionRequired}
                                        onChange={() => setSubscriptionRequired(!subscriptionRequired)}
                                    />
                                    <label className="form-check-label">Enabled</label>
                                </div>
                            </div>

                            {/* Subscription Plans */}
                            {subscriptionRequired && (
                                <div className="mt-4">
                                    <h4 className="text-secondary mb-3">Subscription Plans</h4>
                                    <div className="row">
                                        {Object?.keys(plans).map((plan) => (
                                            <div key={plan} className="col-md-6 col-lg-4 mb-4">
                                                <div className="card h-100 shadow-sm">
                                                    <div className="card-body">
                                                        <div className="d-flex align-items-center justify-content-between mb-2">
                                                            <h5 className="text-capitalize fw-bold mb-0">{plan}</h5>
                                                            <div className="form-check form-switch">
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    checked={plans[plan].enabled}
                                                                    onChange={() =>
                                                                        handlePlanChange(plan, "enabled", !plans[plan].enabled)
                                                                    }
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                >
                                                                    {plans[plan].enabled ? "Enabled" : "Disabled"}
                                                                </label>
                                                            </div>
                                                        </div>
                                                        {plans[plan].enabled && (
                                                            <div className="mt-3">
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={plans[plan].value}
                                                                    onChange={(e) =>
                                                                        handlePlanChange(plan, "value", e.target.value)
                                                                    }
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Save Button */}
                            <div className="text-center mt-4">
                                <button
                                    onClick={handleSubmit}
                                    className="btn btn-primary"
                                    disabled={submitting} // Disable button while submitting
                                >
                                    {submitting ? "Saving..." : "Save Settings"}
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SubscriptionTypes;
